import { render, staticRenderFns } from "./AddReply.vue?vue&type=template&id=2caf1b60&"
import script from "./AddReply.vue?vue&type=script&lang=js&"
export * from "./AddReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports